export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'best-free-software-2024',
    title: '2024年必备的10款免费效率软件推荐',
    excerpt: '为大家精选了10款完全免费的效率工具，涵盖文件管理、笔记记录、截图录屏等多个场景，大幅提升你的工作效率。每一款都经过实际使用体验，值得收藏。',
    content: `<p>在数字化办公时代，一款好用的效率软件可以帮我们节省大量时间。今天91网为大家整理了10款完全免费的效率软件，每一款都经过我们团队的实际使用测试，希望能帮助大家提升工作效率。</p>
<h2>1. Everything - 文件搜索利器</h2>
<p>Everything 是一款极速文件搜索工具，它通过直接读取 NTFS 文件系统的 USN 日志来建立索引，搜索速度远超 Windows 自带搜索。输入关键词的瞬间就能看到结果，是日常办公不可或缺的工具。</p>
<h2>2. Obsidian - 知识管理神器</h2>
<p>Obsidian 是一款基于 Markdown 的本地笔记软件，支持双向链接和知识图谱，非常适合构建个人知识库。所有数据存储在本地，安全可靠，配合丰富的插件生态，功能极其强大。</p>
<h2>3. ShareX - 全能截图工具</h2>
<p>ShareX 不仅仅是一款截图工具，它支持区域截图、窗口截图、滚动截图等多种模式，还内置了图片编辑、OCR 文字识别、屏幕录制等功能，完全免费开源。</p>
<h2>4. Ditto - 剪贴板增强</h2>
<p>Ditto 是 Windows 平台上最强的剪贴板管理工具，它可以记录你复制过的所有内容，支持搜索、分组、同步等功能。再也不用担心复制的内容丢失了。</p>
<h2>5. 7-Zip - 压缩解压利器</h2>
<p>7-Zip 是一款开源免费的压缩解压软件，支持 7z、ZIP、RAR 等多种格式，压缩率极高。界面简洁，没有广告弹窗，是付费压缩软件的最佳替代品。</p>
<h2>6. Snipaste - 贴图截图工具</h2>
<p>Snipaste 的特色功能是可以将截图贴在屏幕上作为参考，对于需要对照文档工作的场景非常实用。截图后按 F3 即可贴图，支持缩放、旋转、设置透明度等操作。</p>
<h2>7. QuickLook - 快速预览</h2>
<p>QuickLook 为 Windows 带来了类似 macOS 的空格预览功能，选中文件后按空格键即可快速预览图片、文档、视频等内容，无需打开对应程序。</p>
<h2>8. PowerToys - 微软官方工具集</h2>
<p>PowerToys 是微软官方出品的 Windows 增强工具集，包含窗口管理器 FancyZones、批量重命名 PowerRename、取色器 Color Picker 等实用功能，持续更新中。</p>
<h2>9. uTools - 效率启动器</h2>
<p>uTools 是一款极简、插件化的桌面效率工具，通过快捷键 Alt+Space 呼出搜索框，可以快速启动应用、搜索文件、执行各种插件功能，是名副其实的效率启动器。</p>
<h2>10. LocalSend - 局域网传输</h2>
<p>LocalSend 是一款开源的局域网文件传输工具，无需互联网连接，支持 Windows、macOS、Linux、Android、iOS 全平台，传输速度快且安全可靠。</p>
<p>以上就是91网为大家推荐的10款免费效率软件，如果你也有好用的工具推荐，欢迎在评论区分享交流！</p>`,
    category: 'software',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20setup%20with%20laptop%20and%20productivity%20software%20screens%2C%20warm%20lighting%2C%20clean%20workspace%2C%20digital%20productivity%20concept%2C%20soft%20neutral%20background%20with%20subtle%20gradients%2C%20editorial%20photography%20style%20with%20natural%20light%20and%20warm%20tones&width=800&height=450&seq=article-software-01&orientation=landscape',
    author: '91网编辑',
    publishDate: '2024-12-15',
    readTime: 8,
    tags: ['效率工具', '免费软件', '软件推荐', '办公效率'],
  },
  {
    slug: 'python-beginner-guide-2024',
    title: '零基础学Python：2024年最全入门学习路线图',
    excerpt: '从零开始系统学习Python编程语言，涵盖基础语法、数据结构、面向对象编程到实战项目的完整学习路径，配合优质学习资源和练习项目。',
    content: `<p>Python 作为目前最流行的编程语言之一，以其简洁优雅的语法和强大的生态体系，成为了众多编程初学者的首选语言。91网为大家整理了一份详细的 Python 入门学习路线图，帮助你从零基础到能够独立完成项目。</p>
<h2>第一阶段：环境搭建与基础语法（2周）</h2>
<p>首先需要安装 Python 解释器和选择一个顺手的代码编辑器。推荐使用 VS Code 配合 Python 插件，或者直接使用 PyCharm Community 版本。学习内容包括：变量与数据类型、运算符、条件判断、循环语句、函数定义等基础概念。</p>
<h2>第二阶段：数据结构深入（2周）</h2>
<p>掌握 Python 的核心数据结构：列表（List）、元组（Tuple）、字典（Dict）、集合（Set）。理解每种数据结构的特点和适用场景，能够灵活运用它们解决实际问题。</p>
<h2>第三阶段：面向对象编程（2周）</h2>
<p>理解面向对象编程的核心概念：类与对象、继承、多态、封装。学习如何使用 Python 进行面向对象设计，编写可维护、可扩展的代码。</p>
<h2>第四阶段：常用库与框架（3周）</h2>
<p>学习 Python 生态中最重要的第三方库：requests（网络请求）、BeautifulSoup（网页解析）、pandas（数据分析）、matplotlib（数据可视化）、Flask/Django（Web 开发）等。</p>
<h2>第五阶段：实战项目（4周）</h2>
<p>通过实际项目巩固所学知识。推荐项目：个人博客系统、数据爬虫工具、自动化办公脚本、简单的数据分析仪表盘等。在实践中遇到问题、解决问题，这是成长最快的方式。</p>
<h2>学习资源推荐</h2>
<ul>
<li>官方文档：docs.python.org - 最权威的参考资料</li>
<li>在线练习：LeetCode、牛客网 - 算法与数据结构练习</li>
<li>视频教程：B站搜索 Python 入门教程</li>
<li>实战平台：GitHub 寻找开源项目参与贡献</li>
</ul>
<p>学习编程贵在坚持，每天保持1-2小时的编码练习，3个月后你就能看到显著的进步。91网将持续为大家提供更多优质的学习资源！</p>`,
    category: 'tutorial',
    coverImage: 'https://readdy.ai/api/search-image?query=Python%20programming%20code%20on%20screen%20with%20warm%20lighting%2C%20minimalist%20coding%20setup%2C%20clean%20desk%20with%20mechanical%20keyboard%2C%20learning%20atmosphere%2C%20soft%20ambient%20light%2C%20modern%20tech%20education%20concept%2C%20warm%20neutral%20tones&width=800&height=450&seq=article-tutorial-01&orientation=landscape',
    author: '91网教程组',
    publishDate: '2024-12-10',
    readTime: 10,
    tags: ['Python', '编程入门', '学习路线', '编程教程'],
  },
  {
    slug: 'top-anime-winter-2024',
    title: '2024冬季新番推荐：这10部动画不容错过',
    excerpt: '冬季新番季来临，91网为大家精选了10部值得追看的动画作品，涵盖热血、搞笑、悬疑、治愈等多种类型，总有一部适合你。',
    content: `<p>又到了每季度最令人期待的新番推荐时间！2024年冬季新番阵容强大，91网编辑部经过认真观看和筛选，为大家精选了以下10部值得追看的新番作品。</p>
<h2>1. 《迷宫饭》第二季</h2>
<p>延续第一季的高质量制作，莱欧斯小队的迷宫美食之旅继续展开。精致的作画和有趣的世界观设定让人欲罢不能，美食与奇幻冒险的完美结合。</p>
<h2>2. 《我推的孩子》第二季</h2>
<p>现象级作品回归，舞台剧篇正式开始。更深入的娱乐圈描写和角色成长，加上高水准的动画制作，本季依然值得期待。</p>
<h2>3. 《葬送的芙莉莲》后半</h2>
<p>芙莉莲的旅途继续，一级魔法使考试篇带来了更多精彩的战斗场面和新角色。细腻的情感刻画和精美的背景美术是这部作品最大的看点。</p>
<h2>4. 《薬屋のひとりごと》第二季</h2>
<p>猫猫在后宫中的推理冒险继续，独特的中华风世界观和精彩的悬疑剧情让人一集接一集停不下来。悠木碧的配音表现出色。</p>
<h2>5. 《我心里危险的东西》第二季</h2>
<p>甜到掉牙的校园恋爱喜剧，市川和山田的关系进一步发展。细腻的心理描写和恰到好处的搞笑元素，是恋爱番中的佼佼者。</p>
<h2>6-10. 更多推荐</h2>
<p>此外，《欢迎来到实力至上主义的教室》第三季、《青之驱魔师》新篇、《物理魔法使马修》第二季、《秒杀外挂太强了》等作品也值得关注。不同类型的作品满足不同观众的需求。</p>
<p>以上就是91网为大家整理的2024冬季新番推荐，你最期待哪一部呢？欢迎在评论区分享你的追番计划！</p>`,
    category: 'entertainment',
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20illustration%20with%20vibrant%20characters%2C%20warm%20cinematic%20lighting%2C%20Japanese%20animation%20aesthetic%2C%20soft%20dreamy%20background%20with%20cherry%20blossoms%2C%20artistic%20composition%2C%20modern%20anime%20art%20style%20with%20rich%20colors&width=800&height=450&seq=article-anime-01&orientation=landscape',
    author: '91网动漫组',
    publishDate: '2024-12-08',
    readTime: 6,
    tags: ['新番推荐', '动漫', '追番指南', '日本动画'],
  },
  {
    slug: 'elden-ring-dlc-guide',
    title: '艾尔登法环：黄金树幽影DLC完整攻略指南',
    excerpt: '全面解析黄金树幽影DLC的新地图、新Boss、新武器和隐藏要素，帮助褪色者们在幽影之地顺利探索，解锁全部结局。',
    content: `<p>《艾尔登法环》的首个大型DLC「黄金树幽影」终于来了！全新的幽影之地地图面积约为宁姆格福的两倍，包含大量新内容。91网游戏组为大家整理了这份完整攻略指南。</p>
<h2>DLC入口与前置条件</h2>
<p>要进入幽影之地，你需要先击败「碎星」拉塔恩和「鲜血君王」蒙格。在蒙格温王朝庙中触碰米凯拉的手掌即可进入DLC区域。建议角色等级在120级以上，武器强化满级后再进入。</p>
<h2>新地图探索要点</h2>
<p>幽影之地分为多个区域：墓地平原、贝瑞特监牢、幽影亚坛、劳弗古遗迹、尖刺山等。每个区域都有独特的敌人配置和隐藏路线。记得多收集幽影树碎片和灵灰来提升在幽影之地的攻防能力。</p>
<h2>主要Boss攻略</h2>
<p><strong>神兽舞狮：</strong>DLC的第一个大型Boss，攻击模式华丽但规律性强。建议使用出血或冻伤流派，注意躲避其多段连击。</p>
<p><strong>双月骑士蕾拉娜：</strong>卡利亚王室的公主，双持两把魔法大剑。近战建议使用高削韧武器打断其施法，远程注意躲避月光魔法。</p>
<p><strong>穿刺者梅瑟莫：</strong>DLC的标志性Boss，拥有两阶段形态。第一阶段注意躲避火焰蛇攻击，第二阶段需要应对其大范围AOE技能。</p>
<p><strong>约定的王拉塔恩：</strong>最终Boss，全盛时期的将军形态。攻击欲望极强，伤害爆炸，建议召唤NPC协助，灵活运用防御反击。</p>
<h2>新武器推荐</h2>
<p>DLC中新增了大量强力武器：反手剑（高攻速出血流）、轻大剑（灵活的重武器新选择）、投掷武器（全新的战斗方式）、格斗术（拳套流崛起）等，值得深入体验。</p>
<p>以上就是黄金树幽影DLC的核心攻略内容，91网将持续更新更多深度攻略！</p>`,
    category: 'games',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20game%20art%20with%20golden%20tree%20and%20epic%20landscape%2C%20mysterious%20atmosphere%2C%20warm%20golden%20light%20rays%2C%20medieval%20fantasy%20aesthetic%2C%20dramatic%20composition%2C%20cinematic%20game%20concept%20art%20with%20soft%20shadows&width=800&height=450&seq=article-games-01&orientation=landscape',
    author: '91网游戏组',
    publishDate: '2024-12-05',
    readTime: 12,
    tags: ['艾尔登法环', 'DLC', '游戏攻略', '魂系游戏'],
  },
  {
    slug: 'powerpoint-templates-collection',
    title: '年终汇报必备：50套高质量PPT模板免费下载',
    excerpt: '年末将至，各种工作总结、年终汇报接踵而至。91网整理了50套高质量PPT模板，涵盖商务、科技、创意等多种风格，助你轻松完成年终汇报。',
    content: `<p>又到了一年一度的年终汇报季，一份精美的PPT能给你的汇报加分不少。91网为大家精心整理了50套高质量PPT模板，全部支持免费下载和使用。</p>
<h2>商务简约风</h2>
<p>适合正式场合的商务汇报，以简洁大方的排版和专业的配色为主。推荐用于公司年度总结、项目汇报、融资路演等正式场合。</p>
<h2>科技感设计</h2>
<p>适合互联网、科技类公司的汇报场景。使用深色背景搭配霓虹色元素，营造前卫的科技氛围。适合产品发布会、技术分享等场景。</p>
<h2>创意扁平化</h2>
<p>活泼的配色和创意的排版设计，适合教育培训、创意设计等行业的汇报。图表和插图元素丰富，让数据展示更加生动有趣。</p>
<h2>中国风典雅</h2>
<p>融入水墨、书法等中国传统文化元素，适合文化类、传统行业的相关汇报。典雅大气，彰显文化底蕴。</p>
<h2>使用技巧</h2>
<ul>
<li>模板下载后建议根据实际内容调整配色和字体</li>
<li>图表数据可以一键替换，无需手动调整格式</li>
<li>所有模板均支持 PowerPoint 2016 及以上版本</li>
<li>部分模板同时提供 Keynote 和 Google Slides 版本</li>
</ul>
<p>91网资源下载频道将持续更新更多优质模板资源，敬请关注！</p>`,
    category: 'resources',
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20modern%20presentation%20slides%20on%20laptop%20screen%2C%20minimalist%20office%20desk%20setup%2C%20professional%20workspace%2C%20warm%20natural%20lighting%2C%20business%20presentation%20concept%2C%20soft%20neutral%20background%2C%20editorial%20style%20photography&width=800&height=450&seq=article-resource-01&orientation=landscape',
    author: '91网资源组',
    publishDate: '2024-12-01',
    readTime: 5,
    tags: ['PPT模板', '年终汇报', '资源下载', '办公模板'],
  },
  {
    slug: 'ai-trends-2025-predictions',
    title: '2025年AI人工智能十大趋势预测：将如何改变我们的生活',
    excerpt: '从大语言模型到AI Agent，从多模态到具身智能，91网带你前瞻2025年AI领域最值得关注的十大趋势，洞察技术变革方向。',
    content: `<p>2024年是AI技术爆发的一年，从ChatGPT引发的全球关注到各类AI应用的遍地开花，人工智能正在深刻改变我们的生活和工作方式。站在2025年的门槛上，91网技术资讯组为大家梳理了最值得关注的十大AI趋势。</p>
<h2>1. AI Agent 走向成熟</h2>
<p>2025年将是AI Agent从概念走向大规模应用的一年。能够自主规划任务、调用工具、执行多步骤操作的AI智能体将出现在编程、客服、办公等多个场景中。AutoGPT、MetaGPT等项目已经展示出巨大潜力。</p>
<h2>2. 多模态AI全面普及</h2>
<p>从GPT-4V到Gemini，多模态AI模型已经能够同时理解文字、图片、音频和视频。2025年多模态能力将成为AI模型的标准配置，视频理解和生成能力将大幅提升。</p>
<h2>3. AI PC与端侧智能</h2>
<p>随着芯片厂商推出集成NPU的处理器，AI能力正在从云端走向终端设备。2025年AI PC将大规模出货，端侧运行大模型成为现实，隐私保护和低延迟成为关键优势。</p>
<h2>4. 具身智能机器人</h2>
<p>人形机器人结合大语言模型，开始具备理解自然语言指令并执行物理任务的能力。Figure、1X、特斯拉Optimus等项目进展迅速，2025年有望在物流和制造业看到实际部署。</p>
<h2>5-10. 更多趋势</h2>
<p>此外，AI编程助手成为开发者标配、AI视频生成质量飞跃、AI教育个性化加速落地、AI安全治理框架完善、AI+科学发现、开源模型与闭源模型竞争等趋势也将深刻影响2025年的技术格局。</p>
<p>91网将持续关注AI领域的最新动态，为大家带来第一手的技术资讯和深度分析！</p>`,
    category: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20concept%20with%20glowing%20neural%20network%20visualization%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20abstract%20digital%20art%2C%20soft%20gradient%20background%2C%20intelligent%20technology%20atmosphere%2C%20modern%20tech%20concept%20art&width=800&height=450&seq=article-tech-01&orientation=landscape',
    author: '91网科技组',
    publishDate: '2024-11-28',
    readTime: 9,
    tags: ['人工智能', 'AI趋势', '科技资讯', '2025预测'],
  },
  {
    slug: 'windows-optimization-guide',
    title: 'Windows系统终极优化指南：让你的电脑快如新机',
    excerpt: '电脑越来越卡？91网教你从系统设置、启动项管理、磁盘清理到硬件升级的全方位优化方案，让你的电脑性能重回巅峰。',
    content: `<p>随着使用时间的增加，Windows系统难免会变得越来越慢。今天91网就为大家带来一份详细的系统优化指南，从软件到硬件，全方位提升你的电脑性能。</p>
<h2>一、启动项优化</h2>
<p>很多软件会默认设置为开机自启，这是拖慢系统启动速度的主要原因。打开任务管理器，在"启动"选项卡中禁用不必要的启动项，建议只保留杀毒软件和必要的驱动程序。</p>
<h2>二、磁盘清理与优化</h2>
<p>使用Windows自带的磁盘清理工具删除临时文件、系统缓存和回收站文件。对于机械硬盘用户，定期进行磁盘碎片整理可以提升读写速度。SSD用户则需要注意不要进行碎片整理，而是使用TRIM优化。</p>
<h2>三、视觉特效调整</h2>
<p>在"系统属性 > 高级 > 性能设置"中，选择"调整为最佳性能"或手动关闭不需要的动画效果。关闭透明效果和动画可以显著提升老旧设备的流畅度。</p>
<h2>四、电源管理设置</h2>
<p>确保电源计划设置为"高性能"模式（台式机）或"平衡"模式（笔记本），避免因为省电设置导致CPU性能受限。</p>
<h2>五、驱动程序更新</h2>
<p>显卡驱动、芯片组驱动等关键驱动保持最新版本可以获得更好的性能和稳定性。建议使用官方工具或Windows Update更新驱动，避免使用第三方驱动工具。</p>
<h2>六、硬件升级建议</h2>
<p>如果软件优化后仍不满意，可以考虑以下硬件升级：加装SSD固态硬盘（最显著的提升）、增加内存容量（8GB → 16GB）、清理CPU散热器灰尘改善散热。</p>
<p>按照以上步骤操作后，你的电脑性能应该会有明显提升。91网将持续分享更多实用技巧！</p>`,
    category: 'software',
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20computer%20desktop%20with%20Windows%20interface%2C%20minimalist%20workspace%2C%20warm%20desk%20lamp%20lighting%2C%20organized%20cable%20management%2C%20modern%20PC%20setup%2C%20soft%20ambient%20light%2C%20productivity%20aesthetic%2C%20cozy%20atmosphere&width=800&height=450&seq=article-software-02&orientation=landscape',
    author: '91网编辑',
    publishDate: '2024-11-25',
    readTime: 7,
    tags: ['系统优化', 'Windows', '电脑技巧', '实用教程'],
  },
  {
    slug: 'web-development-roadmap-2024',
    title: '2024前端开发完整学习路线：从入门到就业',
    excerpt: '前端开发是当前最热门的IT职业之一，91网为想转行或入门前端的小伙伴整理了完整的学习路线图，包含HTML/CSS基础到React框架。',
    content: `<p>前端开发作为互联网行业最热门的岗位之一，吸引了大量学习者的关注。91网教程组结合行业最新需求，为大家整理了一份2024年前端开发的完整学习路线。</p>
<h2>第一阶段：基础三件套（4周）</h2>
<p>HTML5语义化标签、CSS3布局（Flexbox + Grid）、JavaScript ES6+语法。这是前端开发的基石，务必扎实掌握。推荐练习：独立完成一个静态网站页面。</p>
<h2>第二阶段：进阶技能（4周）</h2>
<p>学习版本控制工具Git、包管理器npm/yarn、模块化开发（ES Modules）、CSS预处理器（Sass/Less）、TypeScript基础。这个阶段主要提升工程化能力。</p>
<h2>第三阶段：框架学习（6周）</h2>
<p>选择React或Vue作为主攻框架。推荐React + Next.js路线：学习JSX、组件化、状态管理、React Router、Hooks等核心概念。完成2-3个实战项目。</p>
<h2>第四阶段：全栈拓展（4周）</h2>
<p>学习Node.js基础、Express/Koa框架、数据库基础（MongoDB/PostgreSQL）、RESTful API设计。了解前后端协作的全流程。</p>
<h2>第五阶段：求职准备（2周）</h2>
<p>整理项目作品集、准备技术面试（算法题 + 前端八股文 + 项目经验）、优化简历。推荐在GitHub上维护一个高质量的个人项目。</p>
<p>前端学习需要持续积累和实践，91网祝福每一位学习者都能顺利入行，找到满意的工作！</p>`,
    category: 'tutorial',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20web%20development%20workspace%20with%20code%20editor%20showing%20React%20code%2C%20dual%20monitor%20setup%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20desk%2C%20frontend%20development%20concept%2C%20soft%20neutral%20background%2C%20tech%20education%20atmosphere&width=800&height=450&seq=article-tutorial-02&orientation=landscape',
    author: '91网教程组',
    publishDate: '2024-11-20',
    readTime: 8,
    tags: ['前端开发', 'Web开发', '学习路线', 'React'],
  },
  {
    slug: 'movie-recommendations-december-2024',
    title: '12月观影指南：院线大片与流媒体新片一网打尽',
    excerpt: '2024年最后一个月，电影院和流媒体平台都有哪些值得期待的影片？91网为你整理12月观影指南，从好莱坞大片到国产佳片。',
    content: `<p>2024年的最后一个月，各大影院和流媒体平台都拿出了压箱底的好片。91网影视组为大家整理了一份12月观影指南，帮你规划这个月的观影清单。</p>
<h2>院线大片</h2>
<p><strong>《猎人克莱文》：</strong>索尼漫威宇宙最新力作，亚伦·泰勒-约翰逊主演。R级暴力美学风格，讲述了蜘蛛侠宿敌克莱文的起源故事。</p>
<p><strong>《小小的我》：</strong>易烊千玺主演的温情剧情片，讲述脑瘫患者刘春和的励志故事。影片情感真挚，表演细腻，是年末不容错过的国产佳片。</p>
<p><strong>《魔法坏女巫》：</strong>改编自百老汇同名音乐剧，Ariana Grande 和 Cynthia Erivo 主演。华丽的歌舞场面和精美的视觉效果。</p>
<h2>流媒体新片</h2>
<p><strong>Netflix：</strong>《鱿鱼游戏》第二季终于来了！12月26日全球上线，成奇勋的复仇之旅即将展开。此外《黑鸽》、《随身危机》等原创影片也值得关注。</p>
<p><strong>Disney+：</strong>《星球大战：骷髅组》以儿童视角展开的星战冒险，裘德·洛主演，适合全家观看。</p>
<p><strong>Apple TV+：</strong>《末日地堡》第二季继续讲述地下末日世界的悬疑故事，制作精良。</p>
<p>以上就是91网整理的12月观影指南，这个月你最想看哪一部呢？</p>`,
    category: 'entertainment',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20ambient%20lighting%2C%20film%20projector%20beam%2C%20red%20velvet%20seats%2C%20classic%20cinema%20atmosphere%2C%20soft%20glowing%20lights%2C%20nostalgic%20movie%20experience%2C%20elegant%20composition&width=800&height=450&seq=article-movie-01&orientation=landscape',
    author: '91网影视组',
    publishDate: '2024-11-18',
    readTime: 5,
    tags: ['观影指南', '电影推荐', '流媒体', '院线大片'],
  },
  {
    slug: 'baldurs-gate-3-honor-mode-guide',
    title: '博德之门3荣誉模式攻略：从零到通关的终极指南',
    excerpt: '荣誉模式是博德之门3最具挑战性的难度，91网为大家整理了从建角色到最终战的完整攻略，助你获得金色骰子皮肤！',
    content: `<p>《博德之门3》的荣誉模式是游戏中最具挑战性的难度设置，只有一个存档槽，全队阵亡即永久删档。91网游戏组历经多次尝试，终于整理出了这份完整攻略。</p>
<h2>建角色建议</h2>
<p>推荐使用魅力主控（圣武士、术士或吟游诗人），便于对话检定。队伍配置建议：近战坦克 + 施法者 + 辅助 + 灵活位置。推荐起源角色：影心（牧师）、盖尔（法师）、卡菈克（野蛮人）。</p>
<h2>第一章关键要点</h2>
<p>优先完成翠绿林地周边任务提升等级，在与地精营地的战斗中善用地形和炸药桶。建议在5级后再挑战蜘蛛女王和相位蜘蛛等强力敌人。记得多利用长休触发队友剧情。</p>
<h2>第二章生存指南</h2>
<p>诅咒之地的探索需要全程携带月亮提灯或使用光明法术。在月出之塔中尽量通过对话避免不必要的战斗。凯瑟里克·索姆将军的战斗是本篇最大难点之一，建议先清理所有死灵骷髅。</p>
<h2>第三章博德之门</h2>
<p>进入下城区后首先收集强力装备：巴尔护甲、地狱骑士长弓等传奇物品。奥林和戈塔什的战斗顺序建议先奥林后戈塔什。最终战前确保全员满级12级并准备好足够的药水和卷轴。</p>
<h2>荣誉模式专属技巧</h2>
<ul>
<li>永远保持至少一个角色的隐身药水或迷雾步卷轴用于紧急撤退</li>
<li>传说动作是荣誉模式Boss的专属技能，战斗中务必考虑其影响</li>
<li>善用营地复活：即使有队友阵亡，只要不是全灭就能通过守墓人复活</li>
<li>重要战斗前使用营地施法：防护善恶、援助术等长效Buff</li>
</ul>
<p>祝各位冒险者勇闯荣誉模式，拿到金色骰子！91网将持续更新更多深度攻略。</p>`,
    category: 'games',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20RPG%20game%20scene%20with%20dragon%20and%20medieval%20adventurers%2C%20dramatic%20lighting%2C%20dungeons%20and%20dragons%20aesthetic%2C%20warm%20torch%20light%2C%20cinematic%20game%20concept%20art%2C%20rich%20atmospheric%20composition&width=800&height=450&seq=article-games-02&orientation=landscape',
    author: '91网游戏组',
    publishDate: '2024-11-15',
    readTime: 11,
    tags: ['博德之门3', '荣誉模式', 'RPG', '游戏攻略'],
  },
  {
    slug: 'font-collection-chinese-design',
    title: '中文设计必备：30款免费可商用中文字体合集',
    excerpt: '字体是设计的灵魂。91网整理了30款完全免费且可商用的优质中文字体，涵盖宋体、黑体、楷体、手写体等多种风格。',
    content: `<p>对于设计师来说，选择合适的字体往往能决定作品的最终效果。然而中文字体开发成本高，优质且免费可商用的字体并不多。91网资源组经过仔细筛选和确认授权，为大家整理了30款免费可商用的中文字体。</p>
<h2>宋体系列</h2>
<p><strong>思源宋体：</strong>Adobe与Google联合开发的开源宋体，字重齐全，质量极高，是宋体中的标杆。</p>
<p><strong>霞鹜文楷：</strong>基于Fontworks Klee One的开源字体，兼具宋体的优雅和现代的简洁，非常适合正文排版。</p>
<h2>黑体系列</h2>
<p><strong>思源黑体：</strong>与思源宋体齐名的开源黑体，7种字重全覆盖，UI设计和排版的首选字体。</p>
<p><strong>阿里巴巴普惠体：</strong>阿里出品的免费可商用字体，字形现代简洁，适合电商和互联网场景使用。</p>
<h2>特色字体</h2>
<p><strong>站酷系列：</strong>站酷快乐体、站酷文艺体等多款风格鲜明的免费字体，适合标题和海报设计。</p>
<p><strong>庞门正道标题体：</strong>粗犷有力的标题字体，特别适合电商促销海报和banner设计。</p>
<h2>使用注意事项</h2>
<ul>
<li>下载前请确认字体授权协议，虽然标注免费可商用但建议保留授权文件</li>
<li>部分字体可能不支持繁体中文，使用前请确认字符集覆盖范围</li>
<li>商业项目中建议记录使用的字体及来源，以备授权查询</li>
</ul>
<p>91网资源下载频道将持续更新更多优质设计资源！</p>`,
    category: 'resources',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20calligraphy%20and%20typography%20design%2C%20ink%20brush%20style%2C%20minimalist%20composition%2C%20warm%20rice%20paper%20texture%20background%2C%20traditional%20Chinese%20aesthetic%20with%20modern%20design%2C%20soft%20natural%20lighting%2C%20artistic%20atmosphere&width=800&height=450&seq=article-resource-02&orientation=landscape',
    author: '91网资源组',
    publishDate: '2024-11-12',
    readTime: 6,
    tags: ['中文字体', '免费商用', '设计资源', '字体下载'],
  },
  {
    slug: 'smartphone-comparison-2024-end',
    title: '2024年末旗舰手机横评：iPhone 16 vs 华为Mate 70 vs 小米15',
    excerpt: '年末换机季来临，91网对比评测三款年度旗舰手机的性能、影像、续航和系统体验，帮你做出最适合的选择。',
    content: `<p>2024年末，各大厂商的年度旗舰已经悉数亮相。91网科技组拿到了iPhone 16 Pro Max、华为Mate 70 Pro+和小米15 Pro三款旗舰手机，为大家带来详细的横向对比评测。</p>
<h2>性能对比</h2>
<p>iPhone 16 Pro Max搭载A18 Pro芯片，单核性能依然领先；华为Mate 70 Pro+搭载麒麟9100，多核性能和AI算力表现出色；小米15 Pro搭载骁龙8 Gen 4，GPU游戏性能强势。日常使用三款手机都非常流畅，差距主要体现在极端场景。</p>
<h2>影像系统</h2>
<p>iPhone 16 Pro Max的视频拍摄能力依然是天花板级别，新增的相机控制按钮让操作更加便捷。华为Mate 70 Pro+的XMAGE影像系统在色彩表现和变焦能力上令人惊艳，尤其是10倍以上长焦。小米15 Pro与徕卡合作的影像系统在人像模式和街拍场景中表现突出。</p>
<h2>续航与充电</h2>
<p>华为Mate 70 Pro+的5700mAh大电池配合100W有线快充，续航和回血速度都是三款中最强的。小米15 Pro的5400mAh电池和120W快充紧随其后。iPhone 16 Pro Max虽然电池容量最小，但A18 Pro的能效表现让实际续航并不落下风。</p>
<h2>系统体验</h2>
<p>iOS 18带来了更多自定义选项和AI功能（Apple Intelligence）。HarmonyOS NEXT的纯血鸿蒙生态正在快速完善。HyperOS 2.0在互联互通方面表现出色，小米生态链设备越多体验越好。</p>
<h2>购买建议</h2>
<p>如果你是苹果生态用户，iPhone 16 Pro Max是最稳妥的选择。如果你追求最强拍照能力和商务体验，华为Mate 70 Pro+不会让你失望。如果你看重性价比和游戏体验，小米15 Pro是极佳的选择。</p>
<p>91网科技资讯频道将持续为大家带来最新的数码产品评测！</p>`,
    category: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Three%20modern%20smartphones%20on%20minimalist%20white%20surface%2C%20product%20photography%20style%2C%20warm%20soft%20studio%20lighting%2C%20clean%20composition%2C%20technology%20comparison%20concept%2C%20elegant%20arrangement%2C%20neutral%20background%20with%20subtle%20warm%20tones&width=800&height=450&seq=article-tech-02&orientation=landscape',
    author: '91网科技组',
    publishDate: '2024-11-08',
    readTime: 9,
    tags: ['手机评测', '旗舰手机', '数码产品', '横向对比'],
  },
];